
/******************
 * Vinova Themes  Framework for Prestashop 1.7.x 
 * @package    Nova - PrestaShop 1.7 Theme For Fashion Templates
 * @version    1.0
 * @author    http://vinovathemes.com/
 * @copyright  Copyright (C) October 2013 vinovathemes.com <@emai:vinovathemes@gmail.com>
 * <info@vinovathemes.com>.All rights reserved.
 * @license   GNU General Public License version 1
 * *****************/
/*
 * Custom code goes here.
 * A template should always ship with an empty custom.js
 */


/* home page collections list custom style start*/

$('.section-collection-list').css('background-color','#f2f2f2').css('padding-top', '15px');
$('.section-collection-list .page-width').css('padding-bottom','55px');

$('.home-coll-title').css('margin','18px');
$('.home-coll-name').css('width','85%');
$('.home-coll-view-all').css('margin-top','30px');

$('.btn-home-coll-view-all').css('width', '150px');

/* home page collections list custom style end */

$('#NovBreadcrumbs').css('margin','0px');

// remove view books button from collection list page
$('#glx-collection-list .home-coll-name').remove(); 

$('#glx-home-collections .glx-collections-list-item').remove(); 

function hideViewButton(){
   $('.glx-collections-list-item').addClass('hidden');
}
function showViewButton(pid){
   hideViewButton();
   $('#glx_item_view_'+pid).removeClass('hidden'); 
}

$('#glx-collection-list .mb-10').css('padding-right','60px');

$('.dropdown-menu.dropdown-menu-right').removeClass('text-right');

$('#stickymenu_bottom_mobile').remove();



function hideStates(ctry_code){
  if(ctry_code=='')
    $('#divStateProvinceFilter').hide();
  else
    $('#divStateProvinceFilter').show();      
}

$(document).on('click', '.tag-filter-li', function(){         
	hideFilterTags();

});


 var hideFilterTags = function(){
  
  	$('#li-'+$('#divCountryList').val().toLowerCase()).hide();
  
  	if($('#divCountryList').val() == 'US'){
      	$('#li-'+$('#divStatesUS').val().toLowerCase()).hide(); 
    }else  if($('#divCountryList').val() == 'CA'){
     	$('#li-'+$('#divStatesCA').val().toLowerCase()).hide();            
     }
};


function  hideStatesOfCA(){
  $('.StatesList').addClass('hidden');
  
  if($('#divStatesCA').hasClass('hidden'))
    	$('#divStatesCA').removeClass('hidden');  
}

function hideStatesOfUS(){
  if($('#divStatesUS').hasClass('hidden'))
    	$('#divStatesUS').removeClass('hidden');
}


function setDefaultStateOfUS(){
  
  if($('#divStatesUS').val() ==''){ 
           $('#divStatesUS').val('arizona');           
   }
}

function setDefaultStateOfCA(){
    if($('#divStatesCA').val() ==''){ 
           $('#divStatesCA').val('alberta');           
    }      
}

/* homepage video */
 var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        var player;
        function onYouTubeIframeAPIReady() {
            player = new YT.Player('player', {
                height: '350',
                width: '600',
                videoId: 'OOcZlnNJ_fA',
                events: {
                    'onReady': onPlayerReady,
                }
            });
        }

        function onPlayerReady(event) {
            $('#play_vid').click(function() {
                event.target.playVideo();
            });
        }

        $(document).ready(function() {
            $('#player').hide();
            $('#play_vid').click(function() {
                $('#player').show();
                $('#play_vid').hide();
            });
        });

  var errorClass = 'error-gb';
  var jqErrorClass = '.'+errorClass;
       

function setErrorClass() {
  $(jqErrorClass).css('color', 'red').css('font-size', '13px');
}

function validateRequired(field, label, message = '') {
  var err = '';
  if ($.trim($(field).val()) == '' || $.trim($(field).val()) == '0') {
    if (message == '')
      $(field).after('<div class="error-gb">Specify ' + label + '</div>');
    else
      showCustomErrorMsg(field, message, errorClass);
    err = 'error';
  }
  return err;
}


function validateEmailFormat(field, label, message = '') {
  
  var err = '';
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  if (!emailReg.test($.trim($(field).val()))) {
    if (message == '')
      $(field).after('<div class="error-gb">Specify a valid ' + label + '</div>');
    else
      showCustomErrorMsg(field, message, errorClass);
    err = 'error';
  }
  return err;
}


function showCustomErrorMsg(field, message,errorClass){
  $(field).after('<div class="' + errorClass + '">' + message + '</div>');
}

function GetStates(ccode, c_id, state_id){

  if(ccode == 'CA' || ccode =='US' || ccode == '0')
    $('#DivGbStateProvince').removeClass('hidden');
  else {
    $('#DivGbStateProvince').addClass('hidden');
    $('#GbStateProvince').val('0');
    executeLocations();
  }

  if(ccode == 'CA' || ccode =='US')
    $('#GbStateProvince').html( $('#State'+ccode).html());
  else if(ccode == '0')
    $('#GbStateProvince').html( ' <option value="0"> Select </option>'  );

  $('#CourseList').html('<option value="0"> Select </option>');
  $('#CourseListAlert').html('');

}


// ---------------------------------------------------------
 
function SubmitFormRequestCourse(){
                    
  $(jqErrorClass).remove();
  var hasError = '';

  var CountryError = validateRequired('#GbPurchaseCountry', 'Course Country', 'Select Course Country' );
  hasError += CountryError;

  if(CountryError == ''){                         
    if($('#GbPurchaseCountry').val()=='US' || $('#GbPurchaseCountry').val()=='CA' ){ 
      var StateError = validateRequired('#GbStateProvince', 'Course State/Province', 'Select Course State/Province' );
      hasError += StateError;
    }
  }                          

  hasError += validateRequired('#CourseList', 'Course Name', 'Select Course');
  hasError += validateRequired('#FirstName', 'Name');
  var emailErr = validateRequired('#TxtEmail', 'Email Address');
  hasError += emailErr;
  if (emailErr == '')
    hasError += validateEmailFormat('#TxtEmail', 'Email address', 'Specify a valid Email Address');


  if(hasError != ''){    
    setErrorClass();
    event.preventDefault();
  }  else{
    
    var params = 'c='+$('#GbPurchaseCountry option:selected').text();
    if($('#GbPurchaseCountry').val()=='US' || $('#GbPurchaseCountry').val()=='CA' ){ 
        params = params + '&d='+$('#GbStateProvince option:selected').text();
    }else 
      params = params + '&d=';
    
    params = params + '&course='+$('#CourseList option:selected').text()+ '&cid='+$('#CourseList').val()
    +'&name='+$('#FirstName').val()+'&email='+$('#TxtEmail').val()+'&RequestOrigin=1';
    
    
    $.ajax('https://golflogix.com/SendCourseRequestMail.aspx', {
    type: 'POST', 
    data: params, 
    success: function (data , status, xhr) {
      
      $('#divAjaxResponse').html('Thank you for your request, we will automatically notify you via email when you course becomes available!');
      $('#divAjaxResponse').attr('style', 'padding: 10px;background-color: #edfbed;margin-top: 5px;font-size: 13px;color: #108010; border: solid 1px #d7dfd7;')
      setTimeout(function(){
        $('#divAjaxResponse').html('').removeAttr('style');
      }, 5000);
      
       
    },
    error: function (jqXhr, textStatus, errorMessage) { 
      $('#divAjaxResponse').html('Thank you for your request, we will automatically notify you via email when your course becomes available!');
      $('#divAjaxResponse').attr('style', 'padding: 10px;background-color: #edfbed;margin-top: 5px;font-size: 13px;color: #108010; border: solid 1px #d7dfd7;')
      setTimeout(function(){
        $('#divAjaxResponse').html('').removeAttr('style');
      }, 5000);
    }
});
    
  }
}

if (window.P == null) window.P = "";
if (window.E == null) window.E = "";

var Utf8 = 
{
	// public method for url encoding
	encode : function (string) {
		string = string.replace(/\r\n/g,"\n");
		var utftext = "";

		for (var n = 0; n < string.length; n++) {

			var c = string.charCodeAt(n);

			if (c < 128) {
				utftext += String.fromCharCode(c);
			}
			else if((c > 127) && (c < 2048)) {
				utftext += String.fromCharCode((c >> 6) | 192);
				utftext += String.fromCharCode((c & 63) | 128);
			}
			else {
				utftext += String.fromCharCode((c >> 12) | 224);
				utftext += String.fromCharCode(((c >> 6) & 63) | 128);
				utftext += String.fromCharCode((c & 63) | 128);
			}

		}

		return utftext;
	},

	// public method for url decoding
	decode : function (utftext) {
		var string = "";
		var i = 0;
		var c = c1 = c2 = 0;

		while ( i < utftext.length ) {

			c = utftext.charCodeAt(i);

			if (c < 128) {
				string += String.fromCharCode(c);
				i++;
			}
			else if((c > 191) && (c < 224)) {
				c2 = utftext.charCodeAt(i+1);
				string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
				i += 2;
			}
			else {
				c2 = utftext.charCodeAt(i+1);
				c3 = utftext.charCodeAt(i+2);
				string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
				i += 3;
			}

		}

		return string;
    }
}

function GetXmlHttpObject()
{
     var xmlHttp = null;
    
    try    {
        // Firefox, Opera 8.0+, Safari
        xmlHttp = new XMLHttpRequest();
     }    catch (e)    {
        // Internet Explorer
        try
        {
            xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
        }
        catch (e)
        {
            xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
        }
    }
    
    return xmlHttp;
}


function GetHttp(u, c, t)
{  
    var x =GetXmlHttpObject(); //window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("MSXML2.XMLHTTP.3.0");
    x.open("GET", u, true);
    x.onreadystatechange = function()
    {
      if (x.readyState==4&&x.status==200&&x.responseText){
        c(x.responseText, t, u);
      }
      else if (x.readyState == 4){
        c("{failed}{0}");
        $('#CourseList').html('<option value="0">Select</option>');
      } 
    }
    x.send(null);
}


function GetQueryStringValue(queryString, key, defValue)
{
	if (defValue == null) defValue = "";
	
	queryString = "&" + queryString.split("?").pop() + "&";
	var parts = queryString.split("&" + key + "=");
	return parts.length > 1 ? Utf8.decode(unescape(parts[1].split("&")[0]).split('+').join(' ')) : defValue;
}

 
function responseLocations(response)
{
   
	if (response.indexOf("Success") != 0)
	{
		return;
	}
	
	var lines = response.split("\n");
   
	var hasStates = GetQueryStringValue(lines[0], "HasStates");
	var countryCode = GetQueryStringValue(lines[0], "CountryCode");
	var stateCode = GetQueryStringValue(lines[0], "StateCode");

	var countryIndex = -1, stateIndex = -1;
	var mode;
	var results;
   
	for (var i=0;i<lines.length;i++)
	{
      
      if (lines[i].charAt(0) == "[") {
          mode = lines[i];
      }else if (lines[i].charAt(0) == "{") {
          mode = lines[i];          
          var courses = JSON.parse(mode);          
        	results = courses.CourseInfo;
      }else	{
          
			if (mode == "[COUNTRIES]")
			{
			}
			else if (mode == "[STATES]")
			{
				var parts = lines[i].split(':');
				if (parts.length == 2)
				{
					states.options[states.options.length] = new Option(parts[1], parts[0]);
					if (parts[0].toUpperCase() == stateCode.toUpperCase())
					{
						stateIndex = states.length - 1;
					}
				}
			}
		
			else if (mode == "[RESULTS]")
			{
            
 				 
			}
          
		}
	}
  	showResults(results);
}
 

 
function trim10(str) 
{
	var whitespace = ' \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000';
	for (var i = 0; i < str.length; i++) 
	{
		if (whitespace.indexOf(str.charAt(i)) === -1) 
		{
			str = str.substring(i);
			break;
		}
	}
	for (i = str.length - 1; i >= 0; i--) 
	{
		if (whitespace.indexOf(str.charAt(i)) === -1) 
		{
			str = str.substring(0, i + 1);
			break;
		}
	}
	return whitespace.indexOf(str.charAt(0)) === -1 ? str : '';
}

function showResults(results)
{
  
   $('#CourseListAlert').html('');
	var count = 0;
	var lastLocation = "";
	var html = "";
	var optionsList = '<option value="0"> Select </option>';
   
  	var UnOrderedNames =   [];
  	var CourseOptions =  new Object();
  	
  	var CIdArr = new Array();
  	var CCourseId = new Array();
  	var CNameArr= new Array();
  	var CListArr= new Array();
  	var OptList = '';
  	
  	//console.log(results.length);
  
	for (var i=0;i<results.length;i++)
	{
      	var courseArr= new Array();
      	var courseInf = Object.keys(results[i]).map(function (key) {
        	return [ results[i][key]] ;           
    	}); 
       
      	if(courseInf[10] == 'FALSE' ){
        	CIdArr.push(courseInf[0]);
        	CNameArr.push(courseInf[1]);
        	CListArr[courseInf[1]] = '<option value="'+courseInf[0]+'" >'+ courseInf[1]+'</option>';
      	}
    }
  	if(CNameArr.length > 0){      
    	CNameArr.sort();    
    	for(var c=0; c<CNameArr.length; c++)
      	{
         	OptList += CListArr[ CNameArr[c] ];
      	}
  	}                        
   
  	$('#CourseList').html(optionsList+OptList);
  	var country = $('#GbPurchaseCountry').val();
	if (country == 'US' || country == 'CA')	{
		$('#CourseListAlert').html(CNameArr.length + ' Course' + (CNameArr.length==1?'':'s') + ' Mapped in ' + states.options[states.selectedIndex].text);
	}	else	{      
		$('#CourseListAlert').html(CNameArr.length + ' Course' + (CNameArr.length==1?'':'s') + ' Mapped in ' + countries.options[countries.selectedIndex].text);
	}	
	
}

function fixName(name)
{
	var modified = false;
	var parts = name.split(" - ");
	if (parts.length == 2)
	{
		var facility = parts[0].replace(/^\s*/, "").replace(/\s*$/, "");
		var courseName = parts[1].replace(/^\s*/, "").replace(/\s*$/, "");
		if (facility.toLowerCase().indexOf(courseName.toLowerCase()) == 0)
		{
			name = facility;
        }
        name = name.replace("'", "").replace("'", "");
	}
	return name;
}

 

function selText(box)
{
	if (box.selectedIndex == -1) return "";
	return box.options[box.selectedIndex].text;
}

function selValue(box)
{
	if (box.selectedIndex == -1) return "";
	return box.options[box.selectedIndex].value;
}

function executeLocations()
{
    window.countries = document.getElementById('GbPurchaseCountry');
    window.states = document.getElementById('GbStateProvince');


    window.resultsBox = document.getElementById('CourseList');
  	
  	$('#CourseList').html('<option value="0">Loading...</option>');
  	
	var country = selValue(countries);
	if (country == "" && window.siteRegion != null && window.siteRegion != "")
	{
		country = window.siteRegion;
	}
	if (countries.length == 0)
	{
		if (window.siteRegion != null && window.siteRegion != "")
		{
			country = window.siteRegion;
		}
		else
		{
			country = "US";
		}
	}
	
	if (country == "UK") country = "GB";
	
	var state = selValue(states);
	
	if (state == "" && country == "US") state = "FL";
	if (state == "" && country == "CA") state = "ON";
  
    if(state == 0)
       state = '';
  
//	var requestUrl = "https://www.golflogix.com/CourseSearch.aspx?CountryCode=" + escape(country) + "&StateCode=" + escape(state) + "&CityCode=&City=&OnlyValidCountries=1&Extended=";
	var requestUrl ="https://golflogix.com/CourseSearch.aspx?CountryCode=" + escape(country) + "&StateCode=" + escape(state) + "&City=&OnlyValidCountries=1&Extended=&Puttbreak=&TeeTime=&Lattitude=&Longitude="
  	GetHttp(requestUrl, responseLocations);
}
  
